import { AnimatePresence, motion } from "framer-motion";
export const CartPopupAnimation = ({ children, className, show, }) => {
    return (<AnimatePresence>
            {show && (<motion.div layout key="cartPopup" initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} transition={{ duration: 0.3, ease: [0.55, 0.055, 0.675, 0.19] }} className={className}>
                    {children}
                </motion.div>)}
        </AnimatePresence>);
};
